export const VIDEO_APP_DEF_ID = '14409595-f076-4753-8303-9a86f9f71469';
//# sourceMappingURL=app-def-id.js.map